import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "../App.css";
import maintenanceImage from "../images/maintenance_image.png";
import Header from "./Includes/Header";
import Spacer from "./UI/Spacer";
import { useNavigate } from "react-router-dom";
import Footer from "./Includes/Footer";

const MaintenancePage: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <>
      <Header />
      <Container fluid>
        <Row>
          <Col md={1} />
          <Col md={5}>
            <div className="mt-5 mx-5">
              <Spacer height="200px" />
              <div className="error-header">
                <span className="error-text">{t('errors.maintenance_title')}</span>
                <span className="error-line"></span>
              </div>
              <h2 className="Error-Head">{t('errors.maintenance_subtitle')}</h2>
              <p className="py-4">{t('errors.maintenance_desc')}</p>
              <Button
                className="btn btn-primary py-2 mt-3 rounded-5"
                onClick={() => navigate("/")}
              >
                {t('common.back_home')}
              </Button>
            </div>
          </Col>
          <Col md={6} className="text-center bg-sky">
            <div className="mt-5 mx-5">
              <Spacer height="200px" />
              <img
                src={maintenanceImage}
                alt="Under Maintenance"
                className="img-fluid"
              />
              <Spacer height="110px" />
            </div>
          </Col>
        </Row>
      </Container>
      <Footer full />
    </>
  );
};

export default MaintenancePage;
